import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['menu', 'toggleButton'];

  connect() {
    this._onDocClick = (event) => {
      if (!this.element.contains(event.target)) this.close();
    };
    document.addEventListener('click', this._onDocClick);
  }

  disconnect() {
    document.removeEventListener('click', this._onDocClick);
  }

  toggle(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle('is-open');
  }

  close() {
    this.menuTarget.classList.remove('is-open');
  }
}
